module.exports = __webpack_public_path__ + "static/media/menu-enviroment-corporate.a936a90d.svg";